import React from 'react'
import { Route } from 'react-router-dom'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

import CardHistoryAntd from '../card-history-data/CardHistoryAntd'
import Card95Antd from './Card95Antd'
import Card99Antd from './Card99Antd'
import Card97Antd from './Card97Antd'
import Card97Exclusion from './Card97Exclusion'
import DukeFosCard97Reference from './DuekFosCard97Reference'
import CustomCard97 from './CustomCard97'
import DartReconciliation from './DartReconciliation'
import Card95DataAnalytics from 'nrg-admin/Card95DataAnalytics'
import Card97DataAnalytics from 'nrg-admin/Card97DataAnalytics'
import Card97BreakerVerification from './Card97BreakerVerify'

const CardDataContainer = ({ actionPermits, envConfig }) => {
  const hasDukeCard97Reference = hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.CARD97_DUKE_FOS_REFERENCE],
    matchAny: true,
  })

  const nrgCard95DataAnalytics = hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.NRG_DATA_ANALYTICS_IMPORT_CARD95],
    matchAny: true,
  })

  const nrgCard97DataAnalytics = hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.NRG_DATA_ANALYTICS_IMPORT_CARD97],
    matchAny: true,
  })

  return (
    <>
      {hasDukeCard97Reference && (
        <Route
          exact
          path="/card97-duke-fossil"
          component={DukeFosCard97Reference}
        />
      )}
      {hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.CARD95_HISTORY_VIEWER,
          ScreenPermissions.CARD97_HISTORY_VIEWER,
          ScreenPermissions.CARD99_HISTORY_VIEWER,
        ],
        matchAny: true,
      }) && (
        <Route
          exact
          path="/card-history-data-antd"
          component={CardHistoryAntd}
        />
      )}

      {hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.CARD95_ADMIN,
          ScreenPermissions.CARD95_VIEWER,
        ],
        matchAny: true,
      }) && (
        <Route
          exact
          path="/card95-performance-data-antd"
          component={Card95Antd}
        />
      )}

      {hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.CARD97_ADMIN,
          ScreenPermissions.CARD97_VIEWER,
        ],
        matchAny: true,
      }) && <Route exact path="/card97-event-data" component={Card97Antd} />}
      {hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.CARD97_BREAKER_VERIFY,
          // ScreenPermissions.CARD97_ADMIN,
        ],
        matchAny: true,
      }) && (
        <Route
          exact
          path="/card97-breaker-verify"
          component={Card97BreakerVerification}
        />
      )}

      {hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CARD97_CUSTOM],
        matchAny: true,
      }) && <Route exact path="/custom-card97-data" component={CustomCard97} />}
      {hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CARD97_FE_DART_EVENT_RECONCILIATION],
        matchAny: true,
      }) && (
        <Route
          exact
          path="/pdart-edart-outage"
          component={DartReconciliation}
        />
      )}
      {hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.CARD97_EXCLUSION_EVENT_READ,
          ScreenPermissions.CARD97_EXCLUSION_EVENT_WRITE,
        ],
        matchAny: true,
      }) && (
        <Route exact path="/card97-exclusion" component={Card97Exclusion} />
      )}
      {hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.CARD99_ADMIN,
          ScreenPermissions.CARD99_VIEWER,
        ],
        matchAny: true,
      }) && (
        <Route exact path="/card99-fuel-data-antd" component={Card99Antd} />
      )}

      {nrgCard95DataAnalytics && (
        <Route
          exact
          path="/card95-dataanalytics-import"
          component={Card95DataAnalytics}
        />
      )}

      {nrgCard97DataAnalytics && (
        <Route
          exact
          path="/card97-dataanalytics-import"
          component={Card97DataAnalytics}
        />
      )}
    </>
  )
}
export default CardDataContainer
